import { useLoadingAnimation } from './hooks/useLoadingAnimation';

/**
 * Компонент экрана загрузки для предзагрузки 3D моделей.
 *
 * @param {Object} props
 * @param {boolean} [props.isLoaded] - Флаг завершения реальной загрузки
 * @param {Function} [props.onComplete] - Функция, вызываемая после завершения анимации и загрузки
 */
export function LoadingScreen({ isLoaded = false, onComplete, isFading = false }) {
  const { isReady, loadingProgress, showLogo } = useLoadingAnimation(isLoaded, onComplete);

  return (
    <div className={`loading-screen ${isFading ? 'loading-screen--fading' : ''}`}>
      {/* Центр экрана (viewport), не «между» шапкой и подвалом */}
      <div className="loading-screen__middle">
        <div className="loading-screen__spinner-section">
          <div className={`loading-screen-spinner${isReady ? ' loading-screen-spinner--done' : ''}`} aria-hidden="true">
            <span className="loading-screen-spinner__ring loading-screen-spinner__ring--outer" />
            <span className="loading-screen-spinner__ring loading-screen-spinner__ring--inner" />
          </div>

          <div className={`loading-logo-wrapper ${showLogo ? 'show' : ''}`}>
            <div className="loading-logo-ring loading-logo-ring--1" />
            <div className="loading-logo-ring loading-logo-ring--2" />
            <div className="loading-logo-ring loading-logo-ring--3" />
            <img src="/logo.png" alt="Welland" className="loading-logo-center" />
          </div>
        </div>
      </div>

      <div className="loading-screen__layout">
        <header className="loading-screen__top">
          <div className="loading-screen__brand-section">
            <h1 className="loading-screen__brand-name">
              <span className="loading-screen__brand-welland">WELLAND</span>
              <span className="loading-screen__brand-create">CREATE</span>
            </h1>
            <p className="loading-screen__brand-tagline">
              Решение полноценного подбора оборудования для бассейна
            </p>
          </div>
        </header>

        <footer className="loading-screen__bottom">
          <p className="loading-screen__text">
            {isReady ? 'Система готова к работе!' : 'Инициализация системы подбора оборудования...'}
          </p>
          <div className="loading-screen__progress">
            <div className="progress-bar">
              <div
                className={`progress-bar__fill ${!isReady ? 'loading' : ''}`}
                style={{ width: `${Math.min(loadingProgress, 100)}%` }}
              />
            </div>
            <div className="progress-text">
              {Math.round(Math.min(loadingProgress, 100))}%
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
